export const ChevronUp = ({...rest}) => {
  const style = {fill: 'currentColor', maxWidth: '100%', maxHeight: '100%'};
  return (
    <div {...rest}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
          d="M20.1314 16.1314C19.5065 16.7562 18.4935 16.7562 17.8686 16.1314L12 10.2628L6.13136 16.1314C5.50653 16.7562 4.49346 16.7562 3.86862 16.1314C3.24378 15.5066 3.24378 14.4935 3.86862 13.8687L10.8686 6.86865C11.4935 6.24381 12.5065 6.24381 13.1314 6.86865L20.1314 13.8687C20.7562 14.4935 20.7562 15.5066 20.1314 16.1314Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}